import { gql } from '@apollo/client';

export const CAPTURE_LEAD = gql`
  mutation captureLead($input: CreatOneLeadInput!) {
    captureLead(input: $input) {
      id
      leadIdentifier
      phone
      program
      email
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation verifyMobileAndBookFromWSM($input: VerifyLeadMobileAndBookInput!) {
    verifyMobileAndBookFromWSM(input: $input) {
      data {
        message
      }
      error {
        message
      }
    }
  }
`;

export const RESEND_OTP = gql`
  mutation resendOTP($input: ResendOTPInput!) {
    resendOTP(input: $input) {
      data {
        message
      }
      error {
        message
      }
    }
  }
`;
